<button type="button" class="btn col-md-12 no-pad" *ngIf="!unitLocked" (click)="onClick($event)">
    <i class="fa fa-unlock-alt" aria-hidden="true"></i>

</button>
<button type="button" class="btn col-md-12 no-pad" *ngIf="unitLocked" (click)="onClick($event)"><i class="fa fa-lock" aria-hidden="true"></i></button>

